module.exports = __webpack_public_path__ + "static/media/  (16).e76b1ea0.jpg";